import React from "react";
import "./formulario.scss";
import {
  FormControlLabel,
  FormControl,
  RadioGroup,
  TextField,
  FormHelperText,
  SvgIcon,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
//Componentes
import Header from "../header";
import moment from "moment";
import Loading from "../../../components/loading";
import { Redirect } from "react-router-dom";

const StatusRegistro = {
  Ativo: 1,
  Cancelado: 0
}

const theme = createTheme({
  overrides: {
    MuiFormControlLabel: {
      root: {
        marginLeft: 0,
        marginRight: 0,
      },
    },
    MuiRadio: {
      colorSecondary: {
        "&$checked": {
          color: "#078A34!important",
        },
      },
    },
    MuiFormLabel: {
      root: {
        "&$focused": {
          borderColor: "green",
          color: "black",
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        "&$focused": {
          borderColor: "green",
        },
        "&$focused $notchedOutline": {
          borderColor: "green",
          borderWidth: 1,
        },
      },
    },
    MuiTypography: {
      body1: {
        marginLeft: "35px",
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "0px 10px 15px 10px",
        marginTop: "-10px",
        fontSize: "15px",
      },
    },
  },
});

class Formulario extends React.Component {
  constructor() {
    super();
    this.state = {
      Welcome: true,
      QuestionIndex: 0,
      checarValidacao: false,
      renderModalConfirmacao: false,
      formularioValido: false,
    };
    this.renderModalConfirmacao = this.renderModalConfirmacao.bind(this);
  }

  componentDidMount() {
    const { match, getDadosFormularioAction, history } = this.props;
    const { dados } = this.props.formulario;
    const params = match.params;    

    if (params && params.id) {     
      if (
        Object.entries(dados).length === 0 ||
        (Object.entries(dados).length !== 0 &&
          params.id.toString().toLowerCase() !==
          dados.IdPessoa.toString().toLowerCase())
      )
        getDadosFormularioAction(params.id, history);
    } else {
      history.push("/");
    }
  }

  componentDidUpdate() { }

  getSnapshotBeforeUpdate(nextProps, nextState) {
    if (nextState.checarValidacao || this.state.checarValidacao) {
      var existe = document.getElementById("Error");
      if (existe && (this.state.checarValidacao || nextState.checarValidacao)) {          
        
        existe.parentNode.scrollIntoView(); 

        if (this.state.formularioValido) {          
          this.setState({
            formularioValido: false,
            renderModalConfirmacao: false,
          });          
        }

        return null;
      } else if (
        !this.state.formularioValido &&
        (nextState.checarValidacao || (!existe && this.state.checarValidacao))
      ) {
        this.setState({
          formularioValido: true,
          renderModalConfirmacao: true,
        });
        return null;
      } else return null;
    } else return null;
  }

  renderModalConfirmacao() {
    const { history, setDadosFormularioAction } = this.props;
    return (
      <div>
        <Dialog
          open={this.state.renderModalConfirmacao}
          onClose={() => this.setState({ renderModalConfirmacao: false })}
          aria-labelledby="new-dialog-title"
          fullWidth={true}
        >
          <DialogContent className="bg-white" dividers={true}>
            <div className="w-100 flex-col">
              <SvgIcon
                style={{
                  width: "96px",
                  height: "87px",
                  margin: "40px 0px 40px 0px",
                  alignSelf: "center",
                }}
              >
                <svg
                  width="96"
                  height="87"
                  viewBox="0 0 406 347"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.1951 45.8244V37.521H9.2758C4.57575 37.521 0.75 33.6952 0.75 28.995V8.56987C0.75 3.8698 4.57574 0.0440674 9.2758 0.0440674H86.9265C91.6266 0.0440674 95.4523 3.8698 95.4523 8.56987V28.9951C95.4523 33.6952 91.6266 37.521 86.9265 37.521H26.7818V45.8244H38.6494C44.726 45.8244 49.6718 50.7701 49.6718 56.8468V65.6113C49.6718 67.0473 49.3374 68.4636 48.6952 69.748L44.9168 77.3049C44.2805 78.5775 43.9492 79.9808 43.9492 81.4036C43.9492 84.2426 41.6478 86.5441 38.8087 86.5441H18.4449C14.9931 86.5441 12.1949 83.7459 12.1949 80.2941V79.7278C12.1949 78.0352 11.25 76.5062 9.73617 75.7493L7.07918 74.4209C3.17241 72.4674 0.75 68.5478 0.75 64.1798V52.0744C0.75 48.6226 3.54822 45.8244 7 45.8244H12.1951ZM26.7818 30.1842V34.3793H86.9265C89.8966 34.3793 92.3107 31.9652 92.3107 28.9951V8.56987C92.3107 5.59977 89.8965 3.18569 86.9263 3.18569H9.2758C6.30574 3.18569 3.89162 5.59981 3.89162 8.56987V28.9951C3.89162 31.9652 6.30574 34.3793 9.2758 34.3793H12.1951V30.1842C12.1951 26.1854 15.4791 22.9342 19.4884 22.9342C23.4978 22.9342 26.7818 26.1854 26.7818 30.1842ZM41.2171 77.6798L45.3954 69.3231C46.1418 67.8304 46.5303 66.1845 46.5303 64.5156V56.8468C46.5303 52.5003 42.9963 48.966 38.6496 48.966H25.8902C24.6475 48.966 23.6402 47.9587 23.6402 46.716V30.2276C23.6402 27.9347 21.7814 26.0759 19.4884 26.0759C17.1955 26.0759 15.3367 27.9347 15.3367 30.2276V60.7478C15.3367 61.6154 14.6334 62.3186 13.7659 62.3186C12.8984 62.3186 12.1951 61.6154 12.1951 60.7478V52.716C12.1951 50.645 10.5162 48.966 8.44509 48.966H7.64162C5.57055 48.966 3.89162 50.645 3.89162 52.716V64.1798C3.89162 67.3439 5.65408 70.1959 8.48432 71.6109L11.1413 72.9393C13.7319 74.2345 15.3367 76.8311 15.3367 79.7278C15.3367 81.7573 16.9819 83.4025 19.0114 83.4025H36.819C39.0219 83.4025 40.8078 81.6166 40.8078 79.4136C40.8078 78.8118 40.9479 78.2181 41.2171 77.6798Z"
                    fill="#1B5E20"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.7658 11.239H49.0548C50.0604 11.239 50.8756 12.0542 50.8756 13.0598C50.8756 14.0654 50.0604 14.8806 49.0548 14.8806H13.7658C12.7602 14.8806 11.9449 14.0654 11.9449 13.0598C11.9449 12.0542 12.7602 11.239 13.7658 11.239Z"
                    fill="#1B5E20"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M36.656 22.6843H49.0548C50.0605 22.6843 50.8757 23.4995 50.8757 24.5051C50.8757 25.5107 50.0605 26.326 49.0548 26.326H36.656C35.6504 26.326 34.8352 25.5107 34.8352 24.5051C34.8352 23.4995 35.6504 22.6843 36.656 22.6843Z"
                    fill="#1B5E20"
                  />
                  <path
                    d="M63.5548 18.0252L66 21C66.5 21.5 67 21 67 21L78.2512 12.5663C78.9452 12.0458 79.9298 12.1865 80.4503 12.8805C80.9708 13.5745 80.8302 14.5591 80.1362 15.0796L67.6741 24.4261C66.7255 25.1376 65.3875 24.9907 64.6158 24.0904L61.1695 20.0697C60.6049 19.4111 60.6811 18.4194 61.3398 17.8548C61.9985 17.2902 62.9902 17.3665 63.5548 18.0252Z"
                    fill="#1B5E20"
                  />
                </svg>
              </SvgIcon>
              <div className="w-100 flex-col justify-center">
                <span className="self-center modal-titulo">
                  Confirmar o envio do formulário?
                </span>
                <span className="self-center modal-conteudo">
                  Após o envio, o formulário não poderá ser alterado.
                </span>
                <div className="w-100 row justify-evenly">
                  <button
                    className="botao-voltar"
                    onClick={() =>
                      this.setState({ renderModalConfirmacao: false })
                    }
                  >
                    Cancelar
                  </button>
                  <button
                    className="botao-avancar"
                    onClick={() => {
                      this.setState({ renderModalConfirmacao: false });
                      setDadosFormularioAction(history);
                    }}
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  putMask(value = '') {
    let regex
    if (value.length > 11) {
      regex = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/
      return value.replace(regex, '$1.$2.$3/$4-$5')
    }
    else {
      regex = /(\d{3})(\d{3})(\d{3})(\d{2})$/
      return value.replace(regex, '$1.$2.$3-$4')
    }
  }

  render() {
    const { dados, loadingFormulario } = this.props.formulario;
    const { setRespostaAction, setDadosAction, IdRespostaOutros } = this.props;

    if (loadingFormulario) {
      return <Loading />;
    }

    if (dados !== null && dados.Status === StatusRegistro.Cancelado) {
      return <Redirect to={`/kyc/${this.props.match.params.id}`} />
    }

    return (
      <section className="container w-100">
        {dados && (
          <>
            <div className="titulo-pagina">{dados.Nome}</div>
            <div className="informacoes-container">
              <div className="line">
                <div className="row">
                  <div className="row">
                    <div className="informacoes-titulo">Cliente: </div>
                    <div className="informacoes-descricao">{dados.NomeCliente}</div>
                  </div>
                  <div className="row">
                    <div className="informacoes-titulo"> Gerente: </div>
                    <div className="informacoes-descricao">{dados.NomeGerente}</div>
                  </div>
                  <div className="row">
                    <div className="informacoes-titulo">Preenchido em: </div>
                    <div className="informacoes-descricao">
                      {moment.utc().format("DD/MM/YYYY")}
                    </div>
                  </div>
                </div>
                <div className="row">
                {
                  dados.Documento != null && dados.Documento.length > 11 &&
                  <div className="row">
                    <div className="informacoes-titulo"> CNPJ: </div>
                    <div className="informacoes-descricao">{this.putMask(dados.Documento)}</div>
                  </div>
                }
                {
                  dados.Documento != null && dados.Documento.length <= 11 &&
                  <div className="row">
                    <div className="informacoes-titulo"> CPF: </div>
                    <div className="informacoes-descricao">{this.putMask(dados.Documento)}</div>
                  </div>
                }
                {
                  dados.CNAE != null &&
                  <div className="row">
                    <div className="informacoes-titulo"> CNAE: </div>
                    <div className="informacoes-descricao">{dados.CNAE + " - " + dados.DescricaoCNAE}</div>
                  </div>
                }
                </div>
              </div>

            </div>
            {dados.Assuntos &&
              dados.Assuntos.map((Assunto, indexAssunto) => {
                return (
                  <div
                    className="w-100 h-100"
                    key={Assunto.IdAssuntoFormulario}
                  >
                    <Header title={Assunto.Texto} />
                    {Assunto.Perguntas &&
                      Assunto.Perguntas.map((Pergunta, indexPergunta) => {
                        return (
                          <div
                            className="w-100 pergunta-container mt-10"
                            key={Pergunta.IdPerguntaFormulario}
                          >
                            <ThemeProvider theme={theme}>
                              <div className="pergunta-titulo">
                                {Pergunta.Obrigatorio
                                  ? Pergunta.Texto + " *"
                                  : Pergunta.Texto}
                              </div>
                              <div className="pergunta-descricao">
                                {Pergunta.TextoInformativo}
                              </div>
                              <FormControl
                                className="w-100 flex-col"
                                error={
                                  Pergunta.Obrigatorio &&
                                    this.state.checarValidacao &&
                                    (!Assunto.Perguntas[indexPergunta]
                                      .RespostaEscolhida ||
                                      !Assunto.Perguntas[indexPergunta]
                                        .RespostaEscolhida.IdRespostaFormulario)
                                    ? true
                                    : false
                                }
                              >
                                <RadioGroup
                                  value={Pergunta.IdRespostaFormulario}
                                  className="py-10"
                                >
                                  {Pergunta &&
                                    Pergunta.Respostas.map((item) => {
                                      return (
                                        <FormControlLabel
                                          key={item.IdRespostaFormulario}
                                          className="pergunta-resposta-container"
                                          label={item.Texto}
                                          value={item.IdRespostaFormulario}
                                          control={
                                            <>
                                              <input
                                                type="radio"
                                                checked={
                                                  item.IdRespostaFormulario ===
                                                  (Assunto.Perguntas[
                                                    indexPergunta
                                                  ].RespostaEscolhida &&
                                                    Assunto.Perguntas[
                                                      indexPergunta
                                                    ].RespostaEscolhida
                                                      .IdRespostaFormulario
                                                    ? Assunto.Perguntas[
                                                      indexPergunta
                                                    ].RespostaEscolhida
                                                      .IdRespostaFormulario
                                                    : null)
                                                }
                                                onClick={(ev) => {
                                                  setRespostaAction(
                                                    "IdRespostaFormulario",
                                                    ev.target.value,
                                                    indexPergunta,
                                                    indexAssunto
                                                  );
                                                  if (item.IdRespostaFormulario === '28ec8d1c-3232-493d-af4c-884381bbc5c1')
                                                  setRespostaAction(
                                                    "ComentarioAdicional",
                                                    "",
                                                    indexPergunta,
                                                    indexAssunto
                                                  );
                                                }}
                                                value={
                                                  item.IdRespostaFormulario
                                                }
                                              />
                                              <span className="checkmark"></span>
                                            </>
                                          }
                                        />
                                      );
                                    })}
                                </RadioGroup>
                                {(!Assunto.Perguntas[indexPergunta]
                                  .RespostaEscolhida ||
                                  !Assunto.Perguntas[indexPergunta]
                                    .RespostaEscolhida.IdRespostaFormulario) &&
                                  this.state.checarValidacao &&
                                  Pergunta.Obrigatorio && (
                                    <FormHelperText
                                      id="Error"
                                      className="error"
                                    >
                                      Resposta obrigatória
                                    </FormHelperText>
                                  )}
                              </FormControl>
                              {Pergunta.ComentarioAdicional && (
                                <TextField
                                  id="ComentarioAdicional"
                                  name="ComentarioAdicional"
                                  rows={4}
                                  label="Informações Adicionais"
                                  multiline={true}
                                  variant="outlined"
                                  className="w-100"
                                  disabled={
                                    Pergunta.IdPerguntaFormulario === '87d95cbb-a6ff-44d4-b3e8-8c56d64af757' &&
                                    IdRespostaOutros !== '11cbb4da-adec-491c-a6bc-2f8602bfe0bb'
                                  }
                                  value={
                                    Pergunta.RespostaEscolhida
                                      ? Pergunta.RespostaEscolhida
                                        .ComentarioAdicional
                                      : ""
                                  }
                                  onChange={(ev) => {
                                    setRespostaAction(
                                      "ComentarioAdicional",
                                      ev.target.value,
                                      indexPergunta,
                                      indexAssunto
                                    );
                                  }}
                                  inputProps={{ maxLength: 1000 }}
                                />
                              )}
                            </ThemeProvider>
                          </div>
                        );
                      })}
                  </div>
                );
              })}
            <ThemeProvider theme={theme}>
              <TextField
                id="Comentario"
                name="Comentario"
                rows={5}
                label="Comentário Geral"
                multiline={true}
                variant="outlined"
                className="w-100 mt-10"
                value={dados.Comentario}
                onChange={(ev) => {
                  dados.Comentario = ev.target.value;
                  setDadosAction(dados);
                }}
                inputProps={{ maxLength: 1000 }}
              />
            </ThemeProvider>
            <div className="w-100 justify-right row">
              <button
                className="botao-avancar"
                onClick={() => {
                  this.setState({
                    checarValidacao: true,
                  });
                  if (this.state.formularioValido) {
                    this.setState({
                      renderModalConfirmacao: true,
                    });
                  }                   
                }}
              >
                Enviar
              </button>
            </div>
          </>
        )}
        {this.renderModalConfirmacao()}
      </section>
    );
  }
}

export default Formulario;
